module.exports = __webpack_public_path__ + "static/media/landing-mockup.e0e8c13d.png";